import { useLocation, useNavigate } from "react-router-dom";

export const useSegmentNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const changeLastPathSegment = (
    newSegment: string,
    urlParams?: Record<string, string>,
    deep = 1,
    basePath?: string
  ) => {
    const fullPath = location.pathname;
    const pathAfterBase = basePath ? fullPath.slice(basePath.length) : fullPath;
    const pathParts = pathAfterBase.split('/').filter(Boolean);

    pathParts.splice(-deep, deep, newSegment);
    const newPathAfterBase = '/' + pathParts.join('/');
    const newFullPath = basePath ? basePath + newPathAfterBase : newPathAfterBase;

    const params = new URLSearchParams(urlParams);
    navigate(newFullPath + (params.toString() ? `?${params.toString()}` : ''));
  };

  const addPathSegment = (newSegment: string, basePath?: string) => {  
    const fullPath = location.pathname;
    const pathAfterBase = basePath ? fullPath.slice(basePath.length) : fullPath;
    const pathParts = pathAfterBase.split('/').filter(Boolean);

    pathParts.push(newSegment);
    const newPathAfterBase = '/' + pathParts.join('/');
    const newFullPath = basePath ? basePath + newPathAfterBase : newPathAfterBase;

    navigate(newFullPath + location.search);
  };

  return { changeLastPathSegment, addPathSegment }
};